import * as ApiManager from './_manager';

export const country = {
  list: payload => {
    return ApiManager.callApi (`/config/country/list`);
  },
};
